import Event_bus from "@/utils/event_bus";
import { router } from "@/main";
import { LoginFromTypes } from "./types";
import LoginFromModule from "./loginFromModule";

export const goToLogin = (from?: LoginFromTypes) => {
  LoginFromModule.setPlace(from);
  router.push({
    name: "Login",
    query: {
      routerTransition: "up"
    }
  });
};

export const goToVip = (val: string, situation?: any) => {
  router.push({
    name: "VipPage",
    query: {
      routerTransition: "up",
      comeFrom: val,
      situation
    }
  });
};

export const goToSplash = () => {
  router.replace({
    name: "Splash",
    query: {
      routerTransition: "up"
    }
  });
};

export const goToCoinStore = () => {
  router.push({
    name: "CoinStore",
    query: {
      routerTransition: "up",
      slideIndex: "0"
    }
  });
};

export const goToDoubleCoin = (delay?: boolean) => {
  const delay_time = delay ? 250 : 0;
  setTimeout(() => {
    router.push({
      name: "DoubleCoins",
      query: {
        routerTransition: "up"
      }
    });
  }, delay_time);
};

export const showLiteSearch = (show: boolean, from?: string | undefined) => {
  Event_bus.$emit("show-lite-search", {
    show,
    from
  });
};
